import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cta-toolbar',
  templateUrl: './cta-toolbar.component.html',
  styleUrls: ['./cta-toolbar.component.css']
})
export class CtaToolbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
